import { useEffect } from 'react';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import clsx from 'clsx';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeDynamicCaptionPlugin from 'photoswipe-dynamic-caption-plugin';
import { makeStyles } from '@material-ui/core/styles';
import ImageUploadGalleryItem from './image-upload-gallery-item';
import 'photoswipe/style.css';
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';

const useStyles = makeStyles(() => ({
  gallery: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

const ImageUploadGallery = ({ imageUploads, galleryId }) => {
  const classes = useStyles();

  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: `#gallery-${galleryId}`,
      children: '.pswp-gallery__item',
      pswpModule: () => import('photoswipe'),
    });
    new PhotoSwipeDynamicCaptionPlugin(lightbox, {
      type: 'auto',
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, []);

  if (!imageUploads.length) {
    return <p>No photos yet!</p>;
  }

  return (
    <div className={clsx('pswp-gallery', classes.gallery)} id={`gallery-${galleryId}`}>
      {_map(imageUploads, (imageUpload) => (
        <ImageUploadGalleryItem
          imageUpload={imageUpload}
          key={imageUpload.id}
        />
      ))}
    </div>
  );
};

ImageUploadGallery.propTypes = {
  imageUploads: PropTypes.array,
  galleryId: PropTypes.string.isRequired,
};

export default ImageUploadGallery;
